import React from 'react';
import ReactDOM from 'react-dom/client';
import {
    BrowserRouter,
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from 'react-router-dom';
import { RecoilRoot } from 'recoil';
// import { RecoilURLSyncJSON } from 'recoil-sync';
import * as amplitude from '@amplitude/analytics-browser';
import * as Sentry from '@sentry/react';

import App from './App';
import './i18n';

import { MACHINES_UNDER_ANALYSIS, isDev, isProd, isStage } from './constants';
import { qrState } from './state/recoilState';
import { cltext, getUrlParams } from './utils/general';

import './index.css';






// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initializeState = ({ set }: { set: any }) => {
    const urlQr = getUrlParams('qr');
    set(qrState, urlQr ?? '');

    cltext('initialize sate');
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <>
        {/* <React.StrictMode> */}
    
            <RecoilRoot initializeState={initializeState}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </RecoilRoot>

        {/* </React.StrictMode> */}
    </>
);
